import clsx from "clsx";
import React, { FunctionComponent } from "react";

import { partTypeTire } from "../../../constants/partTypes";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { RoundButton } from "../../../ui/Button/Button";
import { Image } from "../../../ui/Image/Image";
import { TrashIcon } from "../../../ui/icons/TrashIcon";
import { fixTireImageUrl } from "../../../util/fixTireImageUrl";
import { getPartFallbackSrc } from "../../../util/getPartFallbackSrc";
import { gridCellClass } from "./TireComparisonGrid";
import { useTireCompareIds } from "./useTireCompareIds";

type ProductInfoProps = {
  part: TirePartItem;
};

export const ProductInfo: FunctionComponent<ProductInfoProps> = ({ part }) => {
  const [compareIds, { toggle }] = useTireCompareIds();
  return (
    <div className={clsx("pb-2", gridCellClass)}>
      <div className="flex space-x-4 items-end">
        <Image
          className={clsx(
            "w-14 h-14 md:w-20 md:h-20 bg-input rounded-section object-cover object-center",
            "text-transparent scale-x-[-1]"
          )}
          alt="Product Image"
          errorClassName="opacity-20 blur-[8px]"
          fallbackSrc={getPartFallbackSrc(partTypeTire)}
          src={fixTireImageUrl(part.partDetails.primaryPart.tireImageLink)}
        />
        <div className="w-full">
          <h3 className="flex-1 text-[1.16em] md:text-[1.24em] font-medium leading-5 md:leading-5">
            {part.partDetails.primaryPart.tireModelName}
          </h3>
          <div className="flex items-center md:justify-between">
            <img
              alt="Manufacturer Logo"
              className="max-h-5 max-w-[7em] object-cover object-center text-transparent"
              src={part.partDetails.primaryPart.tireManufacturerImage}
            />
            {compareIds.length > 0 && (
              <RoundButton
                onClick={(): void => {
                  toggle(part.partDetails.primaryPart.itemId);
                }}
                aria-label="removeFromCompare"
                className="ml-auto text-xs"
              >
                <TrashIcon className="w-4 h-4" />{" "}
              </RoundButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
